import React, { useEffect, useMemo, useRef, useState } from "react";
import classes from "./Contact.module.css";
import { ReactComponent as EmailIcon } from "../../assets/emailIcon.svg";
import { ReactComponent as PhoneIcon } from "../../assets/phoneIcon.svg";
import { ReactComponent as SecondTruck } from "../../assets/secondTruckSvg.svg";
import { ReactComponent as FirstTruck } from "../../assets/firstTruckSvg.svg";
import ContactFormMainPage from "./ContactFormMainPage";
import useLang from "../../hooks/useLang";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngTuple } from "leaflet";
import NewsDiv from "./ForUs/NewsDiv";
import { getConfigurationValue } from "../../lib/OptionListApi";

const Contact = () => {
	const [position, setPosition] = useState<any>(null);

	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>(null);
	const markerRef = useRef(null);

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	// const ResetCenterView = (props: any) => {
	// 	const { selectedPosition } = props;
	// 	const { addressPosition } = props;
	// 	const map = useMap();
	// 	useEffect(() => {
	// 		if (selectedPosition === 1) {
	// 			map.setView(L.latLng(42.6026, 20.903), map.getZoom(), {
	// 				animate: true,
	// 			});
	// 		} else if (selectedPosition === 2) {
	// 			map.setView(L.latLng(41.1533, 20.1683), map.getZoom(), {
	// 				animate: true,
	// 			});
	// 		} else if (selectedPosition === 3) {
	// 			map.setView(L.latLng(41.6086, 21.7453), map.getZoom(), {
	// 				animate: true,
	// 			});
	// 		}
	// 		if (addressPosition) {
	// 			map.setView(L.latLng(addressPosition), 15, {
	// 				animate: true,
	// 			});
	// 		}
	// 	}, [map, selectedPosition]);

	// 	return null;
	// };

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
				}
			},
		}),
		[]
	);
	const { strings } = useLang("contactFormIndex");

	const [countryId, setCountryId] = useState<any>(null);

	useEffect(() => {
		const fetchCountryId = async () => {
			try {
				const value = await getConfigurationValue(2);
				const countryId = Number(value);
				setCountryId(countryId);
				if (countryId === 2) {
					setMapCenter([41.1533, 20.1683]);
				} else if (countryId === 1) {
					setMapCenter([42.64217, 21.13411]);
				} else if (countryId === 3) {
					setMapCenter([41.6086, 21.7453]);
				}
			} catch (error) {
				console.error("Failed to fetch country ID:", error);
			}
		};
		fetchCountryId();
	}, []);

	return (
		<>
			<div className={classes.bossContainer}>
				<div className={classes.mainContainer}>
					<div className={classes.textContainer}>
						<h1 className={classes.h1Text}>Kontakti</h1>
						{countryId !== 2 && (
							<p className={classes.pText}>
								30 zyre rajonale & 3 Qendra të Logjistikës në
								Kosovë, <br />
								Shqipëri dhe Maqedoninë e Veriut.
							</p>
						)}
					</div>
					<div className={classes.infoContainer}>
						<p className={classes.infoText}>
							<EmailIcon />{" "}
							{countryId && countryId === 1
								? "038 616 626"
								: countryId === 2
								? "+355 69 704 6358"
								: countryId === 3
								? "078 465 465"
								: 0}
						</p>
						<p className={classes.infoText}>
							<PhoneIcon />
							{countryId && countryId === 1
								? "info@postman-ks.com"
								: countryId === 2
								? "info@postman-al.com"
								: countryId === 3
								? "eurokargo21@gmail.com"
								: null}
						</p>
					</div>
					{/* <ContactFormMainPage /> */}
					{/* <InfoDiv /> */}
				</div>
				<div className={classes.fourthContainer}>
					<FirstTruck className={classes.firstTruck} />
					<div className={classes.fourthImageText}>
						{/* <Image src={PostmanTeam} preview={false} /> */}
						<div className={classes.thirdTextContainer}>
							<p className={classes.thirdTitle}>Ekipa jonë</p>
							<p>
								Pas suksesit tonë qëndron forca e ekipit tanë në
								secilën pjesë brenda POSTMAN. Ne jemi një grup
								profesionistësh të përkushtuar, të cilët ndajnë
								një pasion të përbashkët për shërbimet e
								suksesshme të dorëzimit dhe përkushtimin ndaj
								klientit.
							</p>
							<p>
								Secili anëtar i ekipit tonë sjell përvojë të
								pasur dhe aftësi unike që ndihmojnë në ofrimin e
								shërbimeve tona me cilësi të lartë. Duke punuar
								së bashku, ne synojmë të përmbushim dhe
								tejkalojmë pritjet e klientëve dhe jemi gati për
								{"t'i"} përballuar sfidat dhe për të arritur
								suksesin bashkarisht si një ekip.
							</p>
						</div>
						<SecondTruck className={classes.secondTruck} />
						<div className={classes.eighthFirstInfo}>
							<div
								className={classes.eighthFirstInfoContactTitle}
							>
								<p className={classes.contactTitle}>
									Kontakto me ne
								</p>
								<p className="font-inter font-semibold text-xl leading-6 text-gray-700">
									Asistenca për porosi dhe për llogari të
									klientëve:
								</p>
								<div className={classes.eighthInfosContainer}>
									<div
										className={
											classes.eighthFirstInfoContact
										}
									>
										<div className="flex flex-col gap-2">
											<p className="font-bold">
												Orari i punës:
											</p>
											<p>E Hënë - e Premte</p>
											<p> 07:00 - 15:00</p>
											<div className="mt-4">
												<p className="font-bold">
													E-mail:
												</p>
												<p>
													{countryId &&
													countryId === 1
														? "info@postman-ks.com"
														: countryId === 2
														? "info@postman-al.com"
														: countryId === 3
														? "eurokargo21@gmail.com"
														: null}
												</p>
											</div>
										</div>
										<div className="flex flex-col gap-2">
											<p className="font-bold">Tel:</p>
											<p>
												{countryId === 2 ||
												countryId === 3
													? ""
													: "038 616 626"}
											</p>
											<p>
												{countryId === 2
													? "+355 69 703 7712"
													: countryId === 1
													? "+383-49285007"
													: countryId === 3
													? "078 465 465"
													: 0}
											</p>
											<p>
												{" "}
												{countryId === 2
													? "+355 69 704 6358"
													: countryId === 1
													? "+383-46285007"
													: countryId === 3
													? ""
													: 0}
											</p>
										</div>
									</div>

									<div
										className={
											classes.eighthSecondInfoContact
										}
									>
										<p className="font-inter font-semibold text-xl leading-6 text-gray-700">
											Në lidhje me ankesa:
										</p>
										<div className="flex gap-12">
											<div className="flex flex-col gap-2">
												<p className="font-bold">
													Orari i punës:
												</p>
												<p>E Hënë - e Premte</p>
												<p> 07:00 - 15:00</p>
												<div className="mt-4">
													<p className="font-bold">
														E-mail:
													</p>
													<p>
														{countryId &&
														countryId === 1
															? "info@postman-ks.com"
															: countryId === 2
															? "info@postman-al.com"
															: countryId === 3
															? "eurokargo21@gmail.com"
															: null}
													</p>
												</div>
											</div>
											<div className="flex flex-col gap-2">
												<p className="font-bold">
													Tel:
												</p>
												{countryId === 2 ||
												countryId === 3
													? ""
													: "038 616 626"}
												<p>
													{" "}
													{countryId === 2
														? "+355 69 703 7712"
														: countryId === 1
														? "+383-49285007"
														: countryId === 3
														? "078 465 465"
														: 0}
												</p>
												<p>
													{countryId === 2
														? "+355 69 704 6358"
														: countryId === 1
														? "+383-46285007"
														: countryId === 3
														? ""
														: 0}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={classes.eighthMap}>
								<div className={classes.registerFormMap}>
									<div>
										{mapCenter !== null && (
											<MapContainer
												center={mapCenter}
												zoom={7.5}
												scrollWheelZoom={false}
												className={
													classes.mapContainerRegisterForm
												}
											>
												<TileLayer
													attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
													url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
												/>
												{position !== null && (
													<>
														<Marker
															draggable={true}
															position={position}
															icon={customIcon}
															eventHandlers={
																eventHandlers
															}
															ref={markerRef}
														>
															<Popup
																minWidth={90}
															>{`Position${position}`}</Popup>
														</Marker>
													</>
												)}
												{/* <ResetCenterView
													selectedPosition={country}
													addressPosition={
														adressPosition
													}
												/> */}
											</MapContainer>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <NewsDiv /> */}
			</div>
		</>
	);
};

export default Contact;
